import Backbone from "backbone/backbone";
import _ from "underscore/underscore";

import PageView from "front/components/PageView/PageView.js";
import Hero from "front/components/Hero/Hero.js";
import PageTitle from "front/components/PageTitle/PageTitle.js";
import BtnClose from "front/components/BtnClose/BtnClose.js";
import ProjectSide from "front/components/ProjectSide/ProjectSide.js";
import Project from "front/components/Project/Project.js";
import IntroText from "front/components/IntroText/IntroText";

import "./ProjectPage.css";
import template from "./ProjectPage.jinja";


var ProjectPage = PageView.extend({
    el: '.ProjectPage',

    type: 'Project',

    template: template,

    initialize (options) {
        this.options = options || {}

        _.bindAll(this, '_scrollListener', 'animateHeader')

        this.modelId = options.arguments
        this.apiUrl = '/api/pages/work/' + this.modelId + '/'
        this.state = new Backbone.Model({inside: false})
        this.scrollListener = _.throttle(this._scrollListener, 100)
        app.els.$body.addClass('ProjectPageBodyClass');

        PageView.prototype.initialize.call(this, options)
    },

    _scrollListener() {
        let scrollTop = app.els.$window.scrollTop()

        if (scrollTop / app.els.$window.height() > 0.3) {
            if (!this.state.get('inside')) {
                this.state.set('inside', true)
            }
        } else {
            if (this.state.get('inside')) {
                this.state.set('inside', false)
            }
        }
    },

    animateHeader(state) {
        if (state.get('inside')) {
            app.views.nav.minimize()
            app.views.langs.deactivate()
            this.pageTitle.$el.hide()
            // this.pageTitle.$el.hide();
            this.hero.deactivateArrow()
        } else {
            app.views.nav.maximize()
            app.views.langs.activate()
            // this.pageTitle.$el.show();
            this.pageTitle.$el.show()
            this.hero.activateArrow()
        }
    },

    playIn() {
        this.pageTitle.playIn()
            .then(() => {
                return this.hero.activateImage()
            })
            .then(() => {
                app.views.nav.activate({fixed: true});
                app.views.cookie.activate();
                this.hero.activateFrame()
                app.views.logo.activate({delay: 500})
                this.hero.activateArrow()
                this.projectSide.btnSide.playIn()
                this.btnClose.playIn()
                return app.views.langs.activate({
                    delay: 500,
                    fixed: true
                })
            })
            //.then(() => {
            //
            //})
            .then(() => {
                app.els.$body.removeClass('u-NoOverflow')

                this.project.refreshSliders()

                this.listenTo(this.state, 'change:inside', this.animateHeader)
                app.els.$window.on('scroll', this.scrollListener)
            })
    },

    playOut() {
        app.views.langs.deactivate()
        app.views.logo.deactivate();
        return Promise.resolve(this.hero.deactivateImage())
            .then(() => {
                app.els.$body.removeClass('ProjectPageBodyClass');
                this.pageTitle.playOut()
                return app.views.nav.deactivate()
            })
    },

    prepare () {
        this.$el[0].style.display = 'block'

        this.pageTitle = this.views.pageTitle = new PageTitle({
            el: this.$('.PageTitle')
        })

        this.hero = this.views.hero = new Hero({
            el: this.$('.Hero')
        })

        this.btnClose = this.views.btnClose = new BtnClose({
            el: this.$('.Project-close').find('.BtnClose')
        })

        this.project = this.views.project = new Project({
            el: this.$('.Project')
        })

        //this.parallax = this.views.parallax = new Parallax({
        //    el: this.$('.Parallax')
        //})

        this.projectSide = this.views.projectSide = new ProjectSide({
            data: app.data.projects
        });

        this.introText = new IntroText();

        $.Velocity.hook(this.pageTitle.$el, 'opacity', '0')
        $.Velocity.hook(this.hero.$img, 'opacity', '0')

        this.hero.$arrow.addClass('isNotActive isNotTransitioned')
        this.hero.$frame.addClass('isNotActive')

        return this.preloadImages()
            .then(() => {
                return this.promise
            })
            .then(() => {
                app.els.$window.scrollTop(0)
                return app.loader.deactivate()
            })
    },

    cleanUp () {
        app.els.$body.addClass('u-NoOverflow')
        this.close()
        return app.loader.activate()
    }
})

export default ProjectPage



// WEBPACK FOOTER //
// ./assets/app/front/pages/ProjectPage/ProjectPage.js